import React from 'react'
import Review from './review'
import { component_tool } from '../../../tool'
import moment from 'moment'
let { WizInput } = component_tool

let componentName = 'siteOrder'

const columns = [
    {
        title: '预约编号',
        name: 'number',
        searchItem: {},
        tableItem: {
            width: 200,
        },
        formItem: {}
    },
    {
        title: '场地名称',
        name: 'name',
        searchItem: {},
        tableItem: {
            width: 100
        },
        formItem: {}
    },
    {
        title: '场地编号',
        name: 'code',
        searchItem: {},
        tableItem: {
            width: 100,
        },
        formItem: {}
    },
    {
        title: '预约日期',
        name: 'date',
        searchItem: {
            type: 'date~',
            format: 'YYYY-MM-DD',
        },
        tableItem: {
            width: 400,
            type: 'custom',
            render: (text, record) => {
                return <div>{record.start + ' ~ ' + record.end}</div>
            }
        },
        formItem: {
            type: 'custom',
            render: (record) => {
                let { start, end } = record
                let value = start + ' ~ ' + end
                return <WizInput value={value} disabled={true} />
            }
        }
    },
    {
        title: '预约人',
        name: 'fullName',
        dataIndex: 'fullName',
        tableItem: {},
        formItem: {}
    },
    {
        title: '联系电话',
        name: 'orderMobile',
        formItem: {},
        tableItem: {}
    },
    {
        title: '使用类型',
        name: 'useType',
        dict: [
            { code: 0, codeName: '新产品培训' },
            { code: 1, codeName: '实操培训' },
            { code: 2, codeName: '岗位培训' },
            { code: 3, codeName: '区域会议' },
            { code: 4, codeName: '岗位认证' },
            { code: 5, codeName: '其他' },
        ],
        searchItem: {
            type: 'select'
        },
        tableItem: {},
        formItem: {
            type: 'select'
        }
    },
    {
        title: '申请状态',
        name: 'status',
        dataIndex: 'status',
        dict: [
            { code: 0, codeName: '提交审核中' },
            { code: 1, codeName: '审核成功' },
            { code: 2, codeName: '审核失败' },
            { code: 3, codeName: '取消使用' }
        ],
        searchItem: {
            type: 'select'
        },
        tableItem: {},
        formItem: {
            type: 'select'
        }
    },
    {
        title: '审核备注',
        name: 'remark',
        formItem: {
            type: 'custom',
            render: (record) => {
                return <WizInput.TextArea value={record.remark} disabled={true} />
            }
        }
    }
]

const templateConfig = (self) => {
    return {
        mainProps: {},
        content: {
            name: 'WizTableList',
            params: {
                columns,
                searchBarProps: {
                    dataFormat: (params) => {
                        let value = Object.assign({}, params)
                        if (value.date && value.date.length) {
                            value.startDate = moment(value.date[0]).format('YYYY-MM-DD')
                            value.endDate = moment(value.date[1]).format('YYYY-MM-DD')
                        }
                        // delete value.date
                        return value
                    },
                    buttonSort: ['batchReview', 'export'],
                    buttons: [
                        {
                            key: 'batchReview',
                            custom: true,
                            needSelect: true,
                            params: { children: '批量审核', type: 'primary'},
                            customOnClick: {
                                key: 'modal',
                                params: {
                                    modalKey: 'batchReviewModal',
                                    modalParams: {
                                        title: '场地预约批量审核',
                                        footer: null,
                                        width: 750,
                                        diy: (e) => {
                                            let rows = Object.assign([], e.rows)
                                            return <Review rows={rows} changeModal={e.changeModal} />
                                        }
                                    },
                                }
                            }
                        },
                        {
                            key: 'export',
                            custom: true,
                            params: { icon: 'export', children: '导出', type: 'export'},
                            customOnClick: {
                                key: 'action',
                                params: {
                                    apiKey: 'export',
                                    apiParams: {}
                                },
                                formatParams: (rows, record, filters, callback) => {
                                    return { ...filters }
                                }
                            }
                        }
                    ],
                },
                modalFormProps: {},
                dataTableProps: {
                    needOnRowSelect: (record,index)=>{
                        return record.status === 0
                    },
                    rowKey: 'id',
                    selectType: 'checkbox',
                    isScroll: true,
                    loading: false,
                    rowSelection: {
                        getCheckboxProps: (record) => {
                            return { disabled: record.status !== 0 }
                        }
                    }
                },
                rowOperateSort: ['look', 'review'],
                rowOperateView: [
                    {
                        key: 'review',
                        custom: true,
                        params: { children: '审核' },
                        customOnClick: {
                            key: 'modal',
                            params: {
                                modalKey: 'reviewModal',
                                modalParams: {
                                    title: '场地预约审核',
                                    footer: null,
                                    diy: (e) => {
                                        let record = Object.assign({}, e.record)
                                        return <Review record={record} changeModal={e.changeModal} />
                                    }
                                }
                            }
                        },
                        recordChangeParams: ({ record, rows }) => {
                            return { disabled: record.status !== 0 }
                        }
                    }
                ]
            }
        }
    }
}

const apis = (self) => {
    let managerPersonId = self && self._userInfo() && self._userInfo().personId
    return {
        list: {
            path: `${componentName}/listByPage`,
            payload: {
                key: `${componentName}@listByPage_siteAppointmentReview`,
                apiParams: { managerPersonId: managerPersonId || '-1' }
            }
        },
        appointmentReview: {
            path: `${componentName}/update`,
            payload: {
                key: `${componentName}@update`,
                apiParams: {}
            }
        },
        export: {
            path: `${componentName}/export`,
            payload: {
                key: `${componentName}@export_siteAppointmentReview`,
                apiParams: { managerPersonId: managerPersonId || '-1' }
            }
        }
    }
}

let reduxTemplateCofig = (args) => {
    let { self, ...rest } = args
    return {
        apis: apis(self),
        componentName,
        initApiKeys: ['list'],
        keepInitApiParams: true,
        needLoading: true,
        ...rest
    }
}

export { reduxTemplateCofig, templateConfig }

